import { render, staticRenderFns } from "./page-layout.vue?vue&type=template&id=3451d923&scoped=true&"
import script from "./page-layout.vue?vue&type=script&lang=js&"
export * from "./page-layout.vue?vue&type=script&lang=js&"
import style0 from "./page-layout.vue?vue&type=style&index=0&id=3451d923&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3451d923",
  null
  
)

export default component.exports